import {
  HeadMetatags,
  DefaultPageLayout,
  Container,
} from 'routes/components/Layout'
import { getSimilarScenariosByTag } from '../helpers'
import {
  ScenarioTemplateCompact,
  ScenarioTemplateExtended,
  SimilarScenariosData,
} from 'routes/Scenarios/helpers/types'
import { Link } from 'ui-kit/actions/link/Link'
import { Markdown, StyledMarkdownWrapper } from 'routes/components/Shared'
import { ScenarioTitleBlock } from 'routes/Scenarios/Scenario/components/ScenarioTitleBlock'
import { ScenarioConnectors } from 'routes/Scenarios/Scenario/components/ScenarioConnectors'
import { ScenarioGraph } from 'routes/Scenarios/Scenario/components/ScenarioGraph'
import { SimilarScenarios } from './components/SimilarScenarios'
import classes from './Scenario.module.scss'

export const Scenario = ({
  scenario,
  scenarioTemplates,
}: {
  scenario: ScenarioTemplateExtended
  scenarioTemplates: ScenarioTemplateCompact[]
}) => {
  const {
    id,
    key,
    name,
    description,
    shortDescription,
    connectors,
    demoAppUri,
    demoGithubRepo,
    // demoVideoYoutubeUri,
    tags,
  } = scenario ?? {}

  const scenarioTags = tags

  const addToYourAppLink = `${process.env.NEXT_PUBLIC_CONSOLE_URI}/w/0/scenarios/create-scenario/${id}`
  // const embedYouTubeUrl = getEmbedYouTubeUrl(demoVideoYoutubeUri as string)

  const titleBlockData = {
    addScenario: addToYourAppLink,
    name,
    demoAppUri,
    demoGithubRepo,
  }

  const similarScenariosData = scenarioTags.map((tag) => {
    return {
      title: tag,
      items: getSimilarScenariosByTag(tag, key, scenarioTemplates),
    }
  }) as SimilarScenariosData[]

  return (
    <DefaultPageLayout>
      <HeadMetatags title={name} description={shortDescription} />
      <Container className={classes.wrapper}>
        <ScenarioTitleBlock data={titleBlockData} />

        <ScenarioConnectors connectors={connectors} />

        <section className={classes.section}>
          <div className={classes.description}>
            <div className={classes.description_visual}>
              <ScenarioGraph scenario={scenario} />
            </div>

            <StyledMarkdownWrapper className={classes.description_items}>
              {/* {embedYouTubeUrl && (
                <div className={classes.description_video}>
                  <iframe
                    src={embedYouTubeUrl}
                    title='Demo video'
                    allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                    allowFullScreen
                    className={classes.description_iframe}
                  ></iframe>
                </div>
              )} */}
              <Markdown>{description}</Markdown>
            </StyledMarkdownWrapper>
          </div>

          <Link
            className={classes.description_button}
            asPageButton
            type='primary'
            href={addToYourAppLink}
          >
            Add this scenario to Your Product
          </Link>
        </section>

        <SimilarScenarios similarScenarios={similarScenariosData} />
      </Container>
    </DefaultPageLayout>
  )
}

// const getEmbedYouTubeUrl = (url: string, symbol: string = 'v=') => {
//   const baseUrl = 'https://www.youtube.com/embed/'
//   const match = url?.match(new RegExp(`${symbol}(.*)`))

//   return match ? `${baseUrl}${match[1]}` : ''
// }
